// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Command } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconCommand(props: any) {
    return <IconBase icon={Command} {...props} />
  }

  export default IconCommand
  